import { userConstants } from "../../constant";

const initialState = {
  products: [],
  analytics: [],
};

export function sellerBoost(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_SELLER_BOOST_STATUS:
      return {
        ...state,
        products: action.products,
      };
    case userConstants.BOOST_PRODUCT_SUCCESS:
      return {
        ...state,
      };
    case userConstants.GET_BOOST_ANALYTICS:
      return {
        ...state,
        analytics: action.analytics,
      };
    default:
      return state;
  }
}
